// client/src/routes/app/buildings/index.tsx — SCR-BLD-001 „Clădiri" · D-3350 (04 §8.21).
//
// The administrator's list. `Buildings.Manage` is the gate the API enforces on every route of the
// group (02 §6.4); the sidebar hides the entry without it, and this renders SCR-SYS-403 for the URL
// that was typed anyway (§9.2.2).

import { createFileRoute } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { BuildingList } from '@/features/buildings/manage/BuildingList';

export const Route = createFileRoute('/app/buildings/')({
  component: BuildingsScreen,
});

function BuildingsScreen() {
  return (
    <RequirePermission permission="Buildings.Manage">
      <BuildingList />
    </RequirePermission>
  );
}
